import { NgModule } from '@angular/core';
import { SharedModule } from '../shared';
import { ReactiveFormsModule } from '@angular/forms';
import { DocumentsModule } from '../documents/documents.module';
import { UserPermissionsModule } from '../user-permissions/user-permissions.module';
import { CovanceDatePickerModule } from '../covance-date-picker/covance-date-picker.module';
import { NavigationModule } from '../navigation';
import { GlobalPopupModule } from '../global-popup';
import { HeaderTitleModule } from '../header-title';
import { UserModule } from '../user';
import { ToolbarMenuModule } from '../toolbar-menu';
import { NotificationBarModule } from '../notification-bar';
import { LayoutModule } from '../layout';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { NgxPrintModule } from 'ngx-print';
import { MyDatePickerModule } from 'mydatepicker';
import { SiteShippingToolModule } from '../site-shipping-tool/site-shipping-tool.component.module';
import { PendingSampleRegistrationComponent } from './registration/pending-registration.component';
import { RegisteredSamplesComponent } from './registration/registered-samples.component';
import { SampleManagementLevelComponent } from './sample-management-level.component';
import { SampleManagementGuard } from './sample-management-guard';
import { SMWorkspaceLevelLayoutComponent } from './home/sm-workspace-level-layout.component';
import { SMHeaderComponent } from './home/sm-header.component';
import { SMNavigationComponent } from './home/navigation/sm-navigation.component';
import { RegisterSamplesComponent } from './register-samples/register-samples.component';
import { AccessionDetailsComponent } from './register-samples/accession-details/accession-details.component';
import { SampleDetailsService } from './registration/service/sample-details-service';
import { RegisterSampleStorage } from './register-samples/register-sample-storage';
import { SampleDetailsComponent } from './register-samples/sample-details/sample-details.component';
import { AccessionDetailsService } from './register-samples/service/accession-details-service';
import { AdditionalContainerComponent } from './register-samples/additional-container/additional-container.component';
import { OverrideVisitComponent } from './register-samples/accession-details/override-visit/override-visit.component';
import { EreqSmLandingPage } from './ereq-sample-registration/ereq-sm-landing-page/ereq-sm-landing-page.component';
import { EReqSmStorage } from './ereq-sample-registration/ereq-sm-storage';
import { EreqAccessionDetailsComponent } from './register-samples/accession-details/ereq-accession-details.component';
@NgModule({
    declarations: [
        SampleManagementLevelComponent,
        PendingSampleRegistrationComponent,
        RegisteredSamplesComponent,
        SMWorkspaceLevelLayoutComponent,
        SMHeaderComponent,
        SMNavigationComponent,
        RegisterSamplesComponent,
        AccessionDetailsComponent,
        SampleDetailsComponent,
        AdditionalContainerComponent,
        OverrideVisitComponent,
        EreqSmLandingPage,
        EreqAccessionDetailsComponent
    ],
    imports: [
        SharedModule,
        DocumentsModule,
        NavigationModule,
        UserPermissionsModule,
        GlobalPopupModule,
        ReactiveFormsModule,
        UserModule,
        HeaderTitleModule,
        ToolbarMenuModule,
        NotificationBarModule,
        LayoutModule,
        ZXingScannerModule,
        NgxPrintModule,
        MyDatePickerModule,
        CovanceDatePickerModule,
        SiteShippingToolModule,
    ],
    exports: [
        AdditionalContainerComponent,
        OverrideVisitComponent
    ],
    providers: [
        SampleManagementGuard,
        SampleDetailsService,
        RegisterSampleStorage,
        AccessionDetailsService,
        EReqSmStorage
    ],
    entryComponents: [
        AdditionalContainerComponent,
        OverrideVisitComponent
    ],
})
export class SampleManagementModule { }
